import './css/styles.scss';

function introHeroInit() {}

introHeroInit();
